import { useState } from "react";

const useFilter = (errorState) => {
  const [filteredError, setFilteredError] = useState(errorState);

  const removeErrorBySlug = (slug) => {
    setFilteredError((current) => {
      const copy = { ...current };
      // delete copy[slug]
      return copy;
    });

    return filteredError;
  };
  return { filteredError, removeErrorBySlug };
};

export default useFilter;
